import Preview from './preview.js';

const Configurator = {
    slider: null,
    preview: Preview,
    currentStep:  1,

    init() {
        this.currentStep = 1;
        this.initSlider();
        this.initPreview();  
        this.updatePageIndicator(1);      
    },

    initSlider() {

        jQuery('.configurator-slider').on('init', function (event, slick) {

            Configurator.updateSlideStates(1);

        });

        jQuery('.configurator-slider').on('afterChange', function (event, slick, currentSlide) {

            if (currentSlide == 3) {
                jQuery('#quantity').focus();
            }

        });

        this.slider = jQuery('.configurator-slider').slick({
            slidesToShow:   3,
            slidesToScroll: 3,
            initialSlide:   0,
            infinite:       false,
            arrows:         false,
            swipe:          false,
            touchMove:      false,
            draggable:      false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        initialSlide: 0,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow:  1,
                        initialSlide:  1,
                        slidesToScroll: 1,
                        centerMode:    false,
                    }
                }
            ]
        });
    },

    initPreview() {

        if (jQuery('#cable-preview').length == 0) return;

        Preview.init('cable-preview', { controls: false, debugUI: false, debug:false });
        if (window.VendorData?.defaultModelUrl) {
            Preview.loadDefault(
                window.VendorData.defaultModelUrl,
                window.VendorData.defaultEdgeUrl ?? null
            );
        }
    },

    async updatePreview( selection ) {
        const container = document.querySelector( '.wire-preview-container' );

        if ( container ) container.style.opacity = '0.4';

        
        if ( selection.wireId ) {
            await Preview.updateWireSet( selection );
        } else {
            Preview.clearModels();
            if ( window.VendorData?.defaultModelUrl ) {
                await Preview.loadDefault(
                    window.VendorData.defaultModelUrl,
                    window.VendorData.defaultEdgeUrl ?? null
                );
            }
        }

        if ( container ) container.style.opacity = '1';
    },

    goToSlide(index) {
        if (!this.slider) return;
        this.slider.slick('slickGoTo', index);
    },

    nextSlide() {
        if (!this.slider) return;
        this.slider.slick('slickNext');
    },

    prevSlide() {
        if (!this.slider) return;
        this.slider.slick('slickPrev');
    },

    updateSlideStates(currentStep) {
        jQuery('.slick-slide').each(function() {
            const slickIndex = parseInt(jQuery(this).attr('data-slick-index'));
            let enabled;

            if (currentStep === 1) {
                enabled = slickIndex === 1;
            } else {
                enabled = slickIndex <= currentStep - 1;
            }

            if (enabled) {
                jQuery(this).removeAttr('disabled-slide');
            } else {
                jQuery(this).attr('disabled-slide', true);
            }
        });
    },

    updatePageIndicator(currentPage) {
        jQuery('.cf-page').each(function() {
            const itemId = parseInt(jQuery(this).attr('itemid'));
            if (itemId <= currentPage) {
                jQuery(this).addClass('current');
            } else {
                jQuery(this).removeClass('current');
            }
        });
    },
};

export default Configurator;